module.exports = __webpack_public_path__ + "static/img/yahav-large.ac42086.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/yahav-large.jpg
// module id = ixFC
// module chunks = 6